import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal, Spinner } from "react-bootstrap";

import { useGlobalState } from '../../components/globalStateProvider';

import { machineGlassTimeCustomerTableAPI } from '../../api/api_definitions.js';

import GlassTimeTable from './GlassTimeTable.js'

const GlassTimeStartAnalysisCustomer = () => {
    
    const { startDateGlassTimeCustomer, endDateGlassTimeCustomer, 
            machineFamilyGlassTimeCustomer, snMachineGlassTimeCustomer, customerNameGlassTimeCustomer,
            infoGlassTimeCustomer, setInfoGlassTimeCustomer,
            tableGlassTimeCustomer, setTableGlassTimeCustomer,
         } = useGlobalState();

    // Modal window management
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const [loading, setLoading] = useState(true)
    const [startAnalysis, setStartAnalysis] = useState(false)

    // Disable/enable button conditions
    const disableButton = startDateGlassTimeCustomer === null || endDateGlassTimeCustomer === null || snMachineGlassTimeCustomer === "na" || snMachineGlassTimeCustomer === "";

    // Reset the plot by disabling start analysis variable
    useEffect(() => {
        setStartAnalysis(false);
    }, [machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer, snMachineGlassTimeCustomer, startDateGlassTimeCustomer]); 
        

    // Call function to represent data in table
    const startGlassTimeTable = () => {
        setStartAnalysis(true)
        setLoading(true)
        // Manage time range in the correct format
        let year = startDateGlassTimeCustomer.getFullYear();
        let month = String(startDateGlassTimeCustomer.getMonth() + 1).padStart(2, '0'); // Adding 1 to month because it's zero-based
        let day = String(startDateGlassTimeCustomer.getDate()).padStart(2, '0');
        let startDateApi = `${year}-${month}-${day}`;

        year = endDateGlassTimeCustomer.getFullYear();
        month = String(endDateGlassTimeCustomer.getMonth() + 1).padStart(2, '0'); // Adding 1 to month because it's zero-based
        day = String(endDateGlassTimeCustomer.getDate()).padStart(2, '0');
        let endDateApi = `${year}-${month}-${day}`;

        // API GATEWAY RESPONSE MANAGEMENT --> Return glass time table
        machineGlassTimeCustomerTableAPI(machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer, snMachineGlassTimeCustomer, startDateApi, endDateApi)
        .then((dataAPI) => {
            if (dataAPI !== null) {
                console.log("Data machineGlassTimeCustomerTableAPI", dataAPI)
                setLoading(false)
                setInfoGlassTimeCustomer(dataAPI)
                setTableGlassTimeCustomer(JSON.parse(dataAPI.DF_GLASS))
            }      
            else {
                setShow(true)
            }
        })
        .catch((error) => {
            console.log(error)
            setStartAnalysis(false);
            setLoading(true)
            setShow(true)
        });
    };


    // Return loading layout
    if (startAnalysis & loading) {
        return (
            <>
                <Row className="text-center mt-4 mb-4">
                    <Col md={{ span: 4, offset: 4 }}>
                        <p>Caricamento info tempo apertura vetrino cliente...</p>
                        <Spinner animation="border" role="status"></Spinner>
                    </Col>
                </Row>
            </>
        )
    }

    // Return layout
    if (tableGlassTimeCustomer) {
        const lenDF      = Object.values(Object.values(tableGlassTimeCustomer)[0]).length;
        var currentPosts = Object.values(tableGlassTimeCustomer).map(i => Object.values(i).slice(0, lenDF));
    } 

    
    // Return layout
    return (
        <>
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>AVVISO</Modal.Title>
                </Modal.Header>
                <Modal.Body> Nessun o solo alcuni dati sono disponibili </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

            <Row className="text-center mt-4 mb-4">
                <Col md={{ span: 4, offset: 4 }}>
                    <Button size='lg' disabled={disableButton} onClick={startGlassTimeTable}> Inizia Analisi </Button>
                </Col>
            </Row>

            <div className="my-spacer"></div>

            { tableGlassTimeCustomer && startAnalysis && (

                <Row className="text-center mt-2 mb-2">

                    <h5> Tempo totale apertura vetrino: <strong>{infoGlassTimeCustomer.TOTAL_GLASS_TIME}</strong> s</h5>

                    <h5 className="mt-3"> Tempo medio apertura vetrino: <strong>{infoGlassTimeCustomer.AVG_GLASS_TIME}</strong> s</h5>

                    <Row className="mt-4 mb-4">
                        <GlassTimeTable columns={Object.keys(tableGlassTimeCustomer)} posts={currentPosts} />
                    </Row>
                
                </Row>
            )}     
            

        </>
    );  
};
    

export default GlassTimeStartAnalysisCustomer;